import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const CallRatioBackSpreadSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.28915 21.723H15.8009L18.3797 25.4235L22.788 18.7626" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M22.788 18.7626L30.3126 7.29091" stroke="#089981" strokeWidth="2"/>
    </svg>
)


const CallRatioBackSpread: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {CallRatioBackSpreadSvg(props)}
    </SvgIcon>
));
export default CallRatioBackSpread